module.exports = __webpack_public_path__ + "img/groupworks@3x.4f40f17e.webp";